function getParams(url) {
  let urlParams = new URLSearchParams(url.split("?")[1]);

  let params = Object.fromEntries(urlParams);

  return params;
}
export default getParams;
